import axios from "axios";
import {BaseResponse} from "../../BaseResponse";
import {Retest} from "./getRetestList";

export async function getRetest(uid: string) {
    const response = await axios.get<BaseResponse<Retest>>(`/tank/retest/${uid}`)

    return response.data
}